var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"facebook"),React.createElement("path",{"d":"M8,6.67H7V9.93H5.67V6.67H5V5.5h.64V4.77A1.27,1.27,0,0,1,6.8,3.4H8V4.53H7.3a.28.28,0,0,0-.3.26V5.5H8Z","transform":"translate(-5 -3.4)","key":1})]);
}

Facebook.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 3 6.53"};

module.exports = Facebook;

Facebook.default = Facebook;
